import script from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&setup=true&lang=js"

import "../../assets/css/pc/companyModify.css?vue&type=style&index=0&id=6a547c5d&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a547c5d"]])

export default __exports__